import React, { FC } from 'react'

import { CampaignStatusEnum } from 'src/Types/campaigns'
import { StatsBlock } from 'src/Components/StatsSectionBlock'

interface BudgetSectionProps {
  campaignStatus: CampaignStatusEnum
  budget?: string
  spent?: string
}

export const BudgetSection: FC<BudgetSectionProps> = ({
  campaignStatus,
  budget = '-',
  spent = '-',
}) => {
  const budgetSectionVisible = ![
    CampaignStatusEnum.PENDING_APPROVAL,
    CampaignStatusEnum.APPROVED,
  ].includes(campaignStatus)

  if (!budgetSectionVisible) {
    return null
  }

  const sections = [
    {
      title: 'Budget',
      value: `$${budget}`,
    },
    {
      title: 'Spent',
      value: `$${Number(spent)?.toFixed(2)}`,
    },
  ]

  return <StatsBlock sections={sections} />
}
